<script setup lang="ts">
/**
 * CaDialog — membungkus <UModal> (focus-trap & ESC dari reka-ui).
 * Di layar HP tampil sebagai bottom-sheet: jempol ada di bawah, bukan di tengah layar.
 */
defineProps<{ judul?: string; deskripsi?: string }>()
const buka = defineModel<boolean>('open', { default: false })
</script>

<template>
  <UModal
    v-model:open="buka"
    :title="judul"
    :description="deskripsi"
    :ui="{
      overlay: 'bg-black/60',
      content: [
        'bg-surface border border-line',
        'fixed inset-x-0 bottom-0 top-auto w-full max-w-full rounded-t-3xl translate-x-0 translate-y-0',
        'sm:inset-x-auto sm:bottom-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2',
        'sm:max-w-lg sm:rounded-[20px] shadow-sheet'
      ].join(' '),
      header: 'px-5 pt-5 pb-3',
      title: 'ca-h3 text-ink',
      description: 'text-sm text-muted mt-1',
      body: 'px-5 pb-5',
      footer: 'px-5 pb-6 pt-0 flex flex-col-reverse sm:flex-row sm:justify-end gap-2.5'
    }"
  >
    <slot name="pemicu" />
    <template #body><slot /></template>
    <template v-if="$slots.aksi" #footer><slot name="aksi" /></template>
  </UModal>
</template>
